import { PushNotifications } from '@capacitor/push-notifications';
import { isPlatform } from '@ionic/react';

class NotificationService {
  private static instance: NotificationService;

  private constructor() {}

  public static getInstance(): NotificationService {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService();
    }
    return NotificationService.instance;
  }

  async initialize() {
    if (isPlatform('android')) {
      try {
        // Always request permission on Android
        // Request permission explicitly
        await PushNotifications.requestPermissions();
        
        // Check if permission was granted
        const permissionStatus = await PushNotifications.checkPermissions();
        console.log('Push notification permission status:', permissionStatus.receive);
        
        if (permissionStatus.receive !== 'denied') {
          try {
            await PushNotifications.register();
            
            // Handle registration success
            PushNotifications.addListener('registration', (token) => {
              console.log('Push registration success, token:', token.value);
              // Here you would typically send this token to your server
              this.sendTokenToServer(token.value);
            });
            
            // Handle notification received when app is in foreground
            PushNotifications.addListener('pushNotificationReceived', (notification) => {
              console.log('Push notification received:', notification);
            });
            
            // Handle notification click when app is in background
            PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
              console.log('Push notification action performed:', notification);
              // Handle the notification click, e.g., navigate to a specific page
            });
          } catch (registerError) {
            console.error('Error registering for push notifications:', registerError);
            // Don't throw the error - this prevents app crashes if Firebase isn't properly initialized
            // Just log it and continue with app execution
          }
        }
      } catch (error) {
        console.error('Error initializing push notifications:', error);
      }
    }
  }

  private async sendTokenToServer(token: string) {
    // Implement your logic to send the FCM token to your server
    // This could be a Firebase Function, your own API, etc.
    console.log('Sending FCM token to server:', token);
  }
}

export default NotificationService;
